import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=4200d0b0&scoped=true&lang=html&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4200d0b0",
  null
  
)

export default component.exports